import { render } from "./WelcomeScreen.vue?vue&type=template&id=745b6ef3&scoped=true"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"

import "./WelcomeScreen.vue?vue&type=style&index=0&id=745b6ef3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745b6ef3"]])

export default __exports__